<div>
  <canvas #canvas width="600" height="400"></canvas>
</div>
